<div class="navbar-top sidebar_main_div">
  <!-- [ngClass]="fuseConfig.layout.navbar.secondaryBackground" -->
  <!-- <div class="logo">
  <img class="logo-icon" src="assets/images/logos/sm-silq.png">
  <span class="logo-text secondary-text">SILQ</span>
</div> -->
  <div class="navtop-block">
    <div class="navtopwrap">
      <div class="buttons">
        <button
          mat-icon-button
          class="toggle-sidebar-folded"
          (click)="toggleSidebarFolded()"
          fxHide.lt-lg
        >
          <mat-icon class="secondary-text1" style="margin-left: 16px">menu</mat-icon>
        </button>

        <button
          mat-icon-button
          class="toggle-sidebar-opened"
          (click)="toggleSidebarOpened()"
          fxHide.gt-md
        >
          <mat-icon class="secondary-text">arrow_back</mat-icon>
        </button>
      </div>
      @if (defultTheme) {
        <div class="logo barrister">
          <button
            mat-icon-button
            class="fold_sidebar_logo"
            (click)="toggleSidebarFolded()"
            fxHide.lt-lg
          >
            <mat-icon class="secondary-text1" style="margin-left: 16px">menu</mat-icon>
          </button>
          <!-- <img class="logo-icon unfold_sidebar_logo" src="assets/images/logos/silq-logo.png">
        <img class="logo-icon fold_sidebar_logo" src="assets/images/logos/sm-silq-small.png"> -->
          <div class="nav-logo logo-icon unfold_sidebar_logo">
            <img
              class="logo-icon unfold_sidebar_logo"
              src="assets/images/logos/sm-silq-small.png"
            />
            <!-- <span class="logo-textblock" *ngIf="currentUser">{{currentUser.UserName}}</span> -->
            @if (getperefrence) {
              <span class="logo-textblock">{{ getperefrence.USERFULLNAME }}</span>
            }
          </div>
          <img class="logo-icon fold_sidebar_logo" src="assets/images/logos/sm-silq-small.png" />
        </div>
      }

      @if (greenTheme) {
        <div class="logo solicitor">
          <button
            mat-icon-button
            class="fold_sidebar_logo"
            (click)="toggleSidebarFolded()"
            fxHide.lt-lg
          >
            <mat-icon class="secondary-text1" style="margin-left: 16px">menu</mat-icon>
          </button>
          <div class="nav-logo logo-icon unfold_sidebar_logo">
            <img
              class="logo-icon unfold_sidebar_logo"
              src="assets/images/logos/sm-silq-small-user2.png"
            />
            <!-- <span class="logo-textblock" *ngIf="currentUser"> {{currentUser.UserName}}</span> -->
            @if (getperefrence) {
              <span class="logo-textblock">{{ getperefrence.USERFULLNAME }}</span>
            }
          </div>
          <img
            class="logo-icon fold_sidebar_logo"
            src="assets/images/logos/sm-silq-small-user2.png"
          />
        </div>
      }
    </div>
  </div>
  @if (currentUser) {
    <span class="nav-authemail logo-icon unfold_sidebar_logo">
      {{ currentUser.EXPORTACCOUNTSEMAIL }}
    </span>
  }
  @if (getperefrence) {
    <span class="navcaption logo-icon unfold_sidebar_logo">
      {{ getperefrence.BUSINESSNAME }}
    </span>
  }
</div>

<div class="navbar-scroll-container sidebar_btm_div">
  <div class="navbar-content sidebar-footer-search">
    <fuse-navigation
      style="padding-bottom: 20px"
      class="material2"
      layout="vertical"
    ></fuse-navigation>
  </div>
</div>
